module.exports = __webpack_public_path__ + "static/media/gross.36178290.svg";